export default function liveCartCountController() {
  const productId = window.product?.productId;
  const liveCartCount = document.querySelector('.live-cart-count');
  if (!liveCartCount || !productId) return;

  const minCountToShow = liveCartCount.dataset.minCountToShow || 10;
  const text = liveCartCount.querySelector('span').textContent;

  function updateLiveCartCount() {
    fetch(`/apps/ezz-cart-count/cart-count?type=product&id=${productId}`)
      .then((res) => res.json())
      .then((data) => {
        const count = data.count || 0;
        if (count >= minCountToShow) {
          liveCartCount.classList.remove('hidden');
          liveCartCount.querySelector('span').textContent = text.replace('%s', count);
        }
      });
  }

  document.addEventListener(
    'cart:updated',
    debounce(({ detail: { items } }) => {
      updateLiveCartCount();
    }, 500)
  );

  updateLiveCartCount();
}
